<!--
 * @Description : 自定义全局弹框组件
 * @Author      : pishengjun
 * @Date        : 2025-06-18 17:32:02
-->
<template>
  <div class="CustomModalModal">
    <div v-if="mask" class="mask"></div>
    <div class="modalContent">
      <div class="title">
        <slot name="title">{{ title }}</slot>
      </div>
      <div class="content">
        <!-- <div class="icon"><InfoCircleFilled /></div> -->
        <div class="text">
          <slot name="text">{{ text }}</slot>
        </div>
      </div>
      <div v-if="footer" class="footer">
        <slot name="footer">
          <a-button class="btn" @click="onClose">关闭</a-button>
          <a-button class="btn" type="primary" @click="onConfirm">确认</a-button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs } from "vue";

export default defineComponent({
  name: "CustomModal",
  props: {
    title: {
      type: String,
      default: "提示",
    },
    text: {
      type: String,
      default: "",
    },
    mask: {
      type: Boolean,
      default: true,
    },
    footer: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["close", "confirm"],
  setup(props, { emit }) {
    const state = reactive({});
    const event = {
      onClose() {
        emit("close");
      },
      onConfirm() {
        emit("confirm");
      },
    };

    return {
      ...toRefs(state),
      ...event,
    };
  },
});
</script>

<style lang="less" scoped>
.CustomModalModal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.2);
  }
  .modalContent {
    width: 400px;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    background: #fff;
    z-index: 2;
    .title {
      height: 44px;
      line-height: 44px;
      padding: 0 24px;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid #eee;
      background: #1677ff;
      color: #fff;
    }
    .content {
      margin: 20px;
      padding: 10px;
      font-size: 14px;
      color: #333;
      min-height: 60px;
      display: flex;
      align-items: center;
      .icon {
        font-size: 28px;
        color: #1677ff;
        font-weight: bold;
        margin-right: 15px;
      }
      .text {
        font-size: 14px;
        line-height: 1.6;
      }
    }
    .footer {
      margin: 20px;
      display: flex;
      justify-content: center;
      .btn {
        min-width: 88px;
        margin: 0 10px;
      }
    }
  }
}
</style>
